import React from "react";

import { ModelCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function model({ width, onResize }: Column.Options) {
	return base(ColumnId.Model, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default model;
